export default __webpack_public_path__ + "static/media/icon-filled-test.973a85a5.svg";